// React Dependencies
import React, { useEffect, useState } from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import { toast } from 'react-toastify';

// Internal Dependencies
import WaypointEdges from './WaypointEdges';
import { useMallMapStore } from '../../../hook/useMallMapStore';
import apiService from '../../../services.js/apiService';

const EdgeForm = ({ waypointEdges, setWaypointEdges }) => {
  const { selectedWaypoint, setSelectedWaypoint } = useMallMapStore((state) => state);
  const [selectedWaypointEdges, setSelectedWaypointEdges] = useState([]);

  const getWaypointEdges = () => {
    const currentWaypointEdges = [];

    waypointEdges.forEach((edge) => {
      if (
        (edge.waypointAId === selectedWaypoint.id || edge.waypointBId === selectedWaypoint.id)
        && !currentWaypointEdges.some((entry) => entry.id === edge.id)
      ) {
        currentWaypointEdges.push(edge);
      }
    });

    setSelectedWaypointEdges(currentWaypointEdges);
  };

  const highEdgeHandler = (selectedEdge) => {
    let copyWaypointEdges = _.cloneDeep(waypointEdges);

    copyWaypointEdges = _.map(copyWaypointEdges, (edge) => {
      if (edge.id === selectedEdge.id) {
        edge.isHighlight = true;
      } else {
        edge.isHighlight = false;
      }

      return edge;
    });

    setWaypointEdges(copyWaypointEdges);
  };

  const deleteEdgeHandler = async (selectedEdge) => {
    try {
      let copyWaypointEdges = _.cloneDeep(waypointEdges);
      await apiService.deleteEdge(selectedEdge.id);

      copyWaypointEdges = _.filter(copyWaypointEdges, (edge) => edge.id !== selectedEdge.id);
      setWaypointEdges(copyWaypointEdges);
    } catch (err) {
      toast.error('Error deleting waypoint edge');
      console.log(err);
    }
  };

  useEffect(() => {
    getWaypointEdges();
  }, [selectedWaypoint.id, waypointEdges]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <Typography variant="h6">{selectedWaypoint.name}</Typography>
        <CancelOutlinedIcon style={{ cursor: 'pointer' }} fontSize="large" onClick={() => setSelectedWaypoint(null)} />
      </div>
      <div className="mb-3">
        <div className="">
          <Typography variant="h6">Edges</Typography>

          { _.map(selectedWaypointEdges, (edge, index) => (
            <WaypointEdges
              key={index}
              edge={edge}
              onHighlight={highEdgeHandler}
              onDeleteEdge={deleteEdgeHandler}
            />
          )) }
        </div>
      </div>
    </>
  );
};

EdgeForm.propTypes = {
  waypointEdges:    PropTypes.arrayOf(PropTypes.shape(Object)),
  setWaypointEdges: PropTypes.func,
};

EdgeForm.defaultProps = {
  waypointEdges:    [],
  setWaypointEdges: () => {},
};

export default EdgeForm;
